<template>
  <div>
    <h1 class="logo-name">404</h1>
  </div>
</template>
<script>
export default {
  name: "404",
  components: {},
};
</script>
